import { Link, NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { ThemeSwitcher } from './ThemeSwitcher'
import { ProfferLogoMark } from './ProfferLogoMark'

/** Γραμμή συνδέσμων με έμφαση στην ενεργή διαδρομή (χωρίς κουτί). */
const tabClass = ({ isActive }: { isActive: boolean }) =>
  `relative py-3 text-sm font-medium transition after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:rounded-full after:transition-colors sm:text-[0.9375rem] ${
    isActive
      ? 'text-zinc-900 after:bg-violet-600 dark:text-white dark:after:bg-violet-400'
      : 'text-zinc-500 after:bg-transparent hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200'
  }`

export function PublicAuthHeader() {
  const { isLoggedIn, logout, isReady } = useAuth()
  const location = useLocation()
  const packagesTabClass = tabClass({
    isActive: location.pathname.startsWith('/packages'),
  })

  return (
    <header className="sticky top-0 z-20 border-b border-zinc-200/80 bg-white/85 shadow-[0_1px_0_rgba(0,0,0,0.04)] backdrop-blur-lg dark:border-zinc-800/80 dark:bg-zinc-950/85 dark:shadow-[0_1px_0_rgba(255,255,255,0.06)]">
      <div className="mx-auto flex w-full max-w-app items-center justify-between gap-4 px-4 py-2 sm:px-6 sm:py-2.5">
        <Link
          to="/"
          className="group flex min-w-0 flex-1 items-center gap-2.5 sm:max-w-none sm:flex-initial sm:gap-3"
        >
          <ProfferLogoMark className="h-10 w-10 sm:h-11 sm:w-11" rounded="2xl" />
          <div className="min-w-0">
            <p className="truncate text-sm font-semibold tracking-tight text-zinc-900 dark:text-white">
              ProfferAI
            </p>
            <p className="hidden truncate text-[11px] font-normal uppercase tracking-wide text-zinc-400 dark:text-zinc-500 sm:block">
              Προσφορές για επαγγελματίες
            </p>
          </div>
        </Link>

        <div className="flex shrink-0 items-center gap-3 sm:gap-5">
          <nav
            className="flex flex-wrap items-center justify-end gap-x-4 gap-y-1 sm:gap-7"
            aria-label="Λογαριασμός"
          >
            {isReady && isLoggedIn ? (
              <>
                <NavLink to="/packages/basic" className={packagesTabClass}>
                  Πακέτα
                </NavLink>
                <NavLink to="/" className={tabClass}>
                  Πίνακας
                </NavLink>
                <button
                  type="button"
                  onClick={() => logout()}
                  className="py-3 text-sm font-medium text-zinc-500 transition hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200 sm:text-[0.9375rem]"
                >
                  Έξοδος
                </button>
              </>
            ) : (
              <>
                <NavLink to="/packages/basic" className={packagesTabClass}>
                  Πακέτα
                </NavLink>
                <NavLink to="/login" className={tabClass}>
                  Σύνδεση
                </NavLink>
                <NavLink to="/register" className={tabClass}>
                  Εγγραφή
                </NavLink>
              </>
            )}
          </nav>
          <div
            className="hidden h-7 w-px bg-zinc-200 sm:block dark:bg-zinc-700"
            aria-hidden
          />
          <ThemeSwitcher />
        </div>
      </div>
    </header>
  )
}
